import { render, staticRenderFns } from "./_yb.vue?vue&type=template&id=5d29e928&lang=pug&"
import script from "./_yb.vue?vue&type=script&lang=js&"
export * from "./_yb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports